var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearIp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734589694524,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 53329,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M537.362229 1024c-9.510836 0-15.851393-3.170279-22.19195-9.510836l-282.154799-278.98452c-120.470588-123.640867-158.513932-307.517028-91.938081-466.03096S362.996904 6.340557 534.19195 6.340557s329.708978 104.619195 393.114552 263.133127c66.575851 158.513932 28.532508 342.390093-91.938081 466.03096L559.55418 1014.489164c-6.340557 6.340557-12.681115 9.510836-22.191951 9.510836z m0-957.424149C391.529412 66.575851 258.377709 155.343653 201.312693 291.665635c-57.065015 136.321981-25.362229 291.665635 79.256966 396.284829l259.962849 256.79257 259.962848-259.962848c104.619195-104.619195 136.321981-259.962848 79.256966-396.28483-60.235294-133.151703-193.386997-221.919505-342.390093-221.919505z m0 0",
    fill: "currentColor",
    "p-id": 53330
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382.018576 285.325077h63.405573v342.390093h-63.405573V285.325077z m244.111455 342.390093h-63.405573V317.027864c0-15.851393 12.681115-31.702786 31.702787-31.702787h66.575851c60.235294 0 107.789474 47.55418 107.789474 107.789474s-47.55418 107.789474-107.789474 107.789474h-34.873065v126.811145z m0-187.046439h34.873065c25.362229 0 47.55418-22.19195 47.55418-47.55418s-22.19195-47.55418-47.55418-47.554179h-34.873065v95.108359z m0 0",
    fill: "currentColor",
    "p-id": 53331
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIp);
export default __webpack_public_path__ + "static/media/clear-ip.921ae1c136bfe713256ec34329057631.svg";
export { ForwardRef as ReactComponent };